export enum Shruti 
{
    S='S',
    r1="r1",
    r2="r2",
    R1="R1",
    R2="R2",
    G1="G1",
    G2="G2",
    g1="g1",
    g2="g2",
    m1="m1",
    m2="m2",
    M1="M1",
    M2="M2",
    P="P",
    d1="d1"
    ,d2="d2"
    ,D1="D1"
    ,D2="D2",
    n1="n1",
    n2="n2",
    N1="N1",
    N2="N2",

    r="r",

    R="R",

    G="G",
    g="g",
    m="m",

    M="M",


    d="d"
   
    ,D="D",
 
    n="n",
   
    N="N",
    Sl='S.',
    r1l="r1.",
    r2l="r2.",
    R1l="R1.",
    R2l="R2.",
    G1l="G1.",
    G2l="G2.",
    g1l="g1.",
    g2l="g2.",
    m1l="m1.",
    m2l="m2.",
    M1l="M1.",
    M2l="M2",
    Pl="P.",
    d1l="d1."
    ,d2l="d2."
    ,D1l="D1."
    ,D2l="D2.",
    n1l="n1.",
    n2l="n2.",
    N1l="N1.",
    N2l="N2.",

    rl="r.",

    Rl="R.",

    Gl="G.",
    gl='g.',
    ml="m.",

    Ml="M.",


    dl="d."
   
    ,Dl="D.",
 
    nl="n.",
   
    Nl="N.",
   
    Sh="S'",
    r1h="r1'",
    r2h="r2'",
    R1h="R1'",
    R2h="R2'",
    G1h="G1'",
    G2h="G2'",
    g1h="g1'",
    g2h="g2'",
    m1h="m1'",
    m2h="m2'",
    M1h="M1'",
    M2h="M2",
    Ph="P'",
    d1h="d1'"
    ,d2h="d2'"
    ,D1h="D1'"
    ,D2h="D2'",
    n1h="n1'",
    n2h="n2'",
    N1h="N1'",
    N2h="N2'",

    rh="r'",

    Rh="R'",

    Gh="G'",
    gh="g'",
    mh="m'",

    Mh="M'",


    dh="d'"
   
    ,Dh="D'",
 
    nh="n'",
   
    Nh="N'",
   


}


export enum TempoGenre {
  AtiVilambit = "Ati Vilambit",
  Vilambit = "Vilambit",
  Madhyalaya = "Madhyalaya",
  Drut = "Drut",
  Atidrut = "Ati Drut"
}

export enum Marker {
  Sum = 'X',
  Khali = 'O',
  Taali='T',
  None = 'N'
}

export interface Vibhag {
  label: string;
  serialNo: number;
  startBeat: number;
  durationInBeats: number;
  markers: Marker[];
  notation?: string;
  lyrics?: string;
  tablaNotes?: string;
}

export interface TaalType {
  name: string;
  numberOfBeats: number;
  numberOfVibhag: number;
  vibhags: Vibhag[];
  tempoGenre: TempoGenre;
}


export enum  Token 
{

SPACE=" ",
VSEP="|",
BSEP=':',
BRSOUND=',',
BREATH=';',
MEASURE="||",
SILENCE="-",
SUSTAIN="~",

MEENDSTART ="[(",
MEENDEND=")]",
KAN="(k",
MURKI="(m",
CLOSEBRACKET=")",
PRE_GRACE="\\",
POST_GRACE="/",
HIGHER_OCTAVE='"',
LOWER_OCATVE='.',
DUGUNSTART="(2",
TIGUNSTART="(3",
CHOUGUNSTART="(4"


}
export enum Slide {
    MeendBegin="lB",
    MeendEnd="lE",
    MeendStroke="lX",
    MeenContinue="lC"
}

export interface NoteType

{
    shruti:Shruti;
    gunNum: number;
    gunDeno: number;
    count: number;
    // duration = beat Interval * gunNum/gunDeno * count;
    octave:number;
   meend:Slide, 
    kan:Shruti,
    kritan:Shruti,
    kritanCount:number,
    murki: Shruti[]
}

export interface ParsedToken {
    value: string;
    type: keyof typeof Token | keyof typeof Shruti | "NUMBER";
    numberValue?: number;
    lineNumber?:number;
  }

  

  export interface ComplexNoteMem
  {
      meendStart?:boolean, meendEnd?:boolean,
      meendCont?:boolean,
          kanBefore?:string|null, kanAfter?:string|null, 
          shruti?:string, indMidiKey?:number, murki?:string[]|null
          andolan?:false
  }
  export interface NoteMem
  {
    special?:ParsedToken,
    duration?:number,
    gunNumerator?:number,
    gunDeno?:number,
    complexNote?:ComplexNoteMem}
    ;

    export interface PhraseMem
    
        {   
            beatId?: number, 
            relativeBeat?:number
            carryMeend?:boolean,
            carryGun?:number,
             gun?:number ,
             div?:number 
             notes?:NoteMem[]}
       
    export interface VibhagMem
    {
        id:number|string,
        startBeat?:number;
        carryMeend?:boolean,
        carryGun?:number;
        lyrics?:string;
        notesText?:string;
        beats?:PhraseMem[]};
    export interface MeasureMem
    {
      id:number,
      vibhag:VibhagMem[],
      sectionName?:string,
      carryMeend?:boolean,
      carryGun?:number
    }

    export interface AdlibLine {
        id: number | string;
        vibhag: VibhagMem;
        lyrics?: string;
    }
    export interface CompositionSectionMem {
        title: string;
        comment?: string;
        type?: 'rhythmic' | 'adlib';
        measures?: MeasureMem[];
        adlibLines?: AdlibLine[];
        maxAdlibNotesPerLine?: number;
    }
export interface CompositionMem{
        measures?:MeasureMem[];
        tempo:number;
        taal:string;
        raaga?:string;
        beatsPerMeasure:number;
        vibhag:number;
        title?:string;
        description?:string;
        shareId?:string;
        visibility?:'private'|'public'|'unlisted'|'shared';
        pendingShareEmails?:string[];
        pendingSharePhones?:string[];
        aclUid?:Record<string, true>;
        taalData?:any;
        sections?:CompositionSectionMem[];

    }

export interface SongBeatStampMem {
    measure: number;
    beat: number;
    [key: string]: unknown;
}

export interface SongNoteMem {
    noteNumber: number;
    startTimeStamp: string;
    beatStamp: SongBeatStampMem;
    endTimeStamp?: string | null;
    velocityStart?: number | null;
    instrument?: string | null;
    soundObject?: unknown;
    durationBeats?: number | null;
    indianNote?: string;
    [key: string]: unknown;
}

export interface SongMidiRunMem {
    id?: string;
    name?: string;
    log?: unknown;
    notes?: SongNoteMem[];
    [key: string]: unknown;
}

export interface SongMusicalPieceMem {
    id: string;
    title?: string;
    startMeasure: number;
    startBeat: number;
    targetInstrument: string;
    selectedRunIndex: number;
    midiRuns: SongMidiRunMem[];
    measures?: MeasureMem[];
    comment?: string;
}

export interface PieceRenderingMem {
    id: string;
    pieceId: string;
    title?: string;
    instrument: string;
    startMeasure: number;
    measureLength: number;
    relativeOctave?: number;
    relativeVolume?: number;
    enabled?: boolean;
}

export interface SongCompositionMem {
    name: string;
    defaultTempo: number;
    scale: string;
    scaleOctave: number;
    meter: number[];
    taal?: string | null;
    raaga?: string | null;
    beatsPerMeasure: number;
    instruments: string[];
    initialInstruments?: string[];
    musicalPieces: SongMusicalPieceMem[];
    pieceRenderings?: PieceRenderingMem[];
    idCounter: number;
    createdAt?: string;
    updatedAt?: string;
}

export function createSilenceToken(): ParsedToken {
    return {
        value: Token.SILENCE,
        type: "SILENCE"
    };
}

export function createSpecialToken(value?: string | null): ParsedToken {
    switch (value) {
        case Token.SUSTAIN:
            return {
                value: Token.SUSTAIN,
                type: "SUSTAIN"
            };
        case Token.BREATH:
            return {
                value: Token.BREATH,
                type: "BREATH"
            };
        case Token.SILENCE:
        default:
            return createSilenceToken();
    }
}

export function normalizeComplexNoteMem(complexNote?: ComplexNoteMem | null): ComplexNoteMem | undefined {
    if (!complexNote) {
        return undefined;
    }

    return {
        ...complexNote,
        kanBefore: complexNote.kanBefore ?? null,
        kanAfter: complexNote.kanAfter ?? null,
        murki: complexNote.murki ?? [],
        shruti: complexNote.shruti?.trim() || Token.SILENCE
    };
}

export function normalizeNoteMem(note?: NoteMem | null): NoteMem {
    const normalizedComplexNote = normalizeComplexNoteMem(note?.complexNote);
    const normalizedSpecial = note?.special
        ? (typeof note.special === 'string' ? createSpecialToken(note.special) : note.special)
        : createSilenceToken();
    const hasRealShruti = Boolean(
        normalizedComplexNote?.shruti &&
        normalizedComplexNote.shruti !== Token.SILENCE
    );

    return {
        ...note,
        special: hasRealShruti ? undefined : normalizedSpecial,
        complexNote: hasRealShruti ? normalizedComplexNote : undefined
    };
}
      

  
    
